import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

import { JwtModule } from '@auth0/angular-jwt';
import { GCADAModule } from '@GCADA/GCADA.module';
import { GCADASharedModule } from '@GCADA/shared.module';
import { GCADAProgressBarModule, GCADASidebarModule, GCADAConfirmDialogModule } from '@GCADA/components';


import { GCADA } from 'app/GCADA-config';
import { RouteConfig } from './route.config';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { HttpClientService } from './services/http-client.service';

import { HomeLayoutModule } from './home-layout/home-layout.module';
import { MatSnackBarModule, MatIconModule, MatButtonModule } from '@angular/material';
import { VerticalLayout1Component } from './layout/vertical/layout-1/layout-1.component';
import { HttpResponseInterceptorService } from './services/http-response-interceptor.service';
import { HomeVerticalLayoutComponent } from './home-layout/home/vertical-layout/home-vertical-layout.component';
import { HomeComponent } from './main/pages/home/home.component';

//Token getter
export function tokenGetter() {
    return localStorage.getItem('access_token');
}

const appRoutes: Routes = [
    {
        path: '',
        component: HomeVerticalLayoutComponent,
        children: [
            {
                path: 'pages',
                loadChildren: './main/pages/pages.module#PagesModule'
            },
            {
                path: '',
                redirectTo: '/pages/home', pathMatch: 'full'
            }
        ]
    },
    {
        path: '',
        component: VerticalLayout1Component,
        children: [
            {

                path: 'apps',
                loadChildren: './main/admin/admin.module#AdminModule',
                canActivate: [AuthGuard], canActivateChild:[AuthGuard]
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/pages/home'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        HttpModule,
        HttpClientModule,

        RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules }),

        TranslateModule.forRoot(),

        //JWT Token
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                skipWhenExpired: true
            }
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatSnackBarModule,
        MatButtonModule,
        MatIconModule,

        //Spinner Module
        NgxSpinnerModule,

        // GCADA modules
        GCADAModule.forRoot(GCADA),
        GCADAConfirmDialogModule,
        GCADAProgressBarModule,
        GCADASidebarModule,
        GCADASharedModule,

        // App modules
        LayoutModule,
        HomeLayoutModule
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        {
            provide: Http,
            useClass: HttpResponseInterceptorService,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpResponseInterceptorService,
            multi: true
        },
        HttpClientService, RouteConfig, AuthService, AuthGuard
    ]
})
export class AppModule {
}
